import BaseComponent from "../../../../lib/components/BaseComponent";
import PropTypes from "prop-types";
import HorizontalLayout from "../../../../lib/components/layouts/HorizontalLayout";
import CampaignCardNew from "../../components/campaign/CampaignCardNew";
import VerticalLayout from "../../../../lib/components/layouts/VerticalLayout";
import shortid from "shortid";
import CM from "../../../model/system/CM";
import ReadCampaignInfo from "../../../model/service/campaign/dto/ReadCampaignInfo";
import ReadCampaignStatus from "../../../model/service/campaign/dto/ReadCampaignStatus";
import CampaignDashBoard from "../../components/campaignDashBoard/CampaignDashBoard";
import React, {createRef} from "react";
import {toast} from "react-toastify";
import he from 'he';
import CampaignList from "../../components/campaign/CampaignList";
import CampaignCard from "../../components/campaign/CampaignCard";
import {ToggleButton, ToggleButtonGroup} from "@mui/material";
import {ViewList, ViewModule} from "@mui/icons-material";
import BaseTab from "../../components/tabbar/BaseTab";
import GF from "../../../../lib/utils/GF";

class CnerOverview extends BaseComponent {

  static LAYOUT_GRID = 'GRID';
  static LAYOUT_LIST = 'LIST';

  constructor(props) {
    super(props);
    this.mainPanel = CM.get().getPanel();
    this.sideBar = this.mainPanel.layoutRef.current.sideBarRef.current;
    this.state = {
      filterText: null,
      activeStatusFilter: null,
      campaigns: [],
      timeOutHandler: undefined,
      layoutType: this.getLayoutType()
    }
  }

  componentDidMount() {
    this.fetchData('', this.state.filterText, this.state.activeStatusFilter);
    this.sideBar.clearMenu();
    this.sideBar.setState(this.sideBar.state);
  }

  fetchData(campaignId = '', search = '', statusFilter = 0) {
    let self = this;
    this.doDataFetch(new ReadCampaignInfo(campaignId, search, statusFilter), 'campaign', (response) => {
      if (response.success) {
        if (response.data.campaigns !== undefined && response.data.campaigns !== null &&
          Array.isArray(response.data.campaigns)) {
          let campaigns = response.data.campaigns;
          self.fetchData_addCampaigns(campaigns);
        }
      } else {
        toast.error('Campaigns konnten nicht gelesen werden!');
      }
    });
  }

  fetchData_addCampaigns(campaigns) {
    if (campaigns !== null) {
      this.state.campaigns = [];
      let self = this;

      campaigns.map((campaign) => {
        if (campaign.eventDateTime && campaign.eventDateTime !== 'n/a') {
          campaign.eventDateTime = GF.stringToDateTime(campaign.eventDateTime);
        } else {
          campaign.eventDateTime = null;
        }
      });

      let filteredCampaigns = self.filterCampaignsByEventDate(campaigns);
      filteredCampaigns.map((campaign) => {
        let status = self.convertStatusToIntValue(campaign.status.text);
        const eventDateTime = self.parseEventDateTime(campaign.eventDateTime);
        this.state.campaigns.push({
          id: campaign.campaignId,
          name: he.decode(campaign.title),
          description: he.decode(campaign.description),
          baseUrl: campaign.link,
          createdDate: campaign.createdDate,
          createdBy: campaign.createdBy,
          eventDateTime: campaign.eventDateTime,
          status: status,
          thumbnail: campaign.img,
          mailGenerateRoute: campaign.mailGenerateRoute
        });
      });
      this.setState(this.state);
    }
  }

  parseEventDateTime = (eventDateTime) => {
    const raw = eventDateTime?.date;
    if (!raw) return new Date(0);

    const isoString = raw.replace(' ', 'T').split('.')[0];

    const date = new Date(isoString);
    return isNaN(date.getTime()) ? new Date(0) : date;
  }

  filterCampaignsByEventDate = (campaigns) => {
    campaigns.sort((a, b) =>
        this.parseEventDateTime(b.eventDateTime).getTime()
        - this.parseEventDateTime(a.eventDateTime).getTime())
    return campaigns;
  }

  convertStatusToIntValue = (status) => {
    switch (status) {
      case 'IN BEARBEITUNG':
        return 1;
      case 'IN WARTUNG':
        return 2;
      case 'VERÖFFENTLICHT':
        return 3;
      case 'ABGESCHLOSSEN':
        return 4;
    }
  }

  onCampaignCardClick(e, campaign) {
    let self = this;
    CM.get().doJsonAjax(CM.get().getServiceUrl('campaign'), new ReadCampaignStatus(campaign.id), function(response) {
      if (response.success) {
        let data = {
          description: response.data.info['Campaign-Beschreibung'],
          campaignId: response.data.info['Campaign-ID'],
          name: response.data.info['Campaign-Name'],
          createdBy: response.data.info['Erstellt von'],
          createdDateTime: response.data.info['Erstellt am'],
          eventStartDateTime: response.data.info['Event-Start-Datum'],
          eventEndDateTime: response.data.info['Event-End-Datum'],
          releasedBy: response.data.info['Freigegeben am'],
          campaignLink: response.data.info['Link'],
          campaignBaseUrl: response.data.info['campaignBaseUrl'],
          status: response.data.info['Status'],
          statistic: response.data.statistic,
          mailGenerateRoute: campaign.baseUrl + campaign.mailGenerateRoute + '/'
        }
        let campaignIdForTabBar = 'tbId_' + response.data.info['Campaign-ID'].value;
        let campaignDashBoard = <CampaignDashBoard ref={createRef()} data={data} id={campaignIdForTabBar}/>;

        CM.get().setCampaignUrl(data.campaignBaseUrl);
        self.mainPanel.horizontalTabBarRef.current.addTab(<BaseTab tabTitle={data.campaignId.value + ': ' +
          he.decode(data.name.value)}/>, campaignDashBoard, campaignIdForTabBar);
      } else {
        toast.error('Campaigns konnten nicht geladen werden!');
      }
    });
  }

  onResetFilters(e) {
    this.state.activeStatusFilter = 0;
    this.state.filterText = '';
    this.fetchData('', this.state.filterText, this.state.activeStatusFilter);
  }

  onFilterInputChange(e, id, value) {
    if (this.state.timeOutHandler !== undefined) {
      clearTimeout(this.state.timeOutHandler);
    }
    this.state.filterText = value;
    this.state.timeOutHandler = setTimeout(() => {
      this.fetchData('', this.state.filterText, this.state.activeStatusFilter);
    }, 400);
  }

  onTabClick(id, mode) {
    if (this.props.id === id) {
      this.sideBar.refreshMenu();
    }
  }

  setOnStatusFilterChange(e, newFilter) {
    this.state.activeStatusFilter = newFilter;
    this.fetchData('', this.state.filterText, this.state.activeStatusFilter);
  }

  changeLayout(layout) {
    CM.get().setGlobalValue('Campaign_Layout_Type', layout);
    this.state.layoutType = layout;
    this.setState(this.state);
  }

  getLayoutType = () => {
    return CM.get().getGlobalValue('Campaign_Layout_Type');
  }

  render() {
    let campaigns = this.state.campaigns.map((campaign, index) => {
      if (CM.get().getGlobalValue('Campaign_Layout_Type') === CnerOverview.LAYOUT_GRID) {
        if (this.state.activeStatusFilter === campaign.status) {
          return <CampaignCard key={shortid()} index={index} campaign={campaign} reloadCampaigns={(e) => this.fetchData(
            '', '', 0)} onCardClick={(e, campaign) => this.onCampaignCardClick(e, campaign)}/>
        } else {
          return <CampaignCard key={shortid()} index={index} campaign={campaign} reloadCampaigns={(e) => this.fetchData(
            '', '', 0)} onCardClick={(e, campaign) => this.onCampaignCardClick(e, campaign)}/>
        }
      } else {
        if (this.state.activeStatusFilter === campaign.status) {
          return <CampaignList key={shortid()} index={index} campaign={campaign} reloadCampaigns={(e) => this.fetchData(
            '', '', 0)} onCardClick={(e, campaign) => this.onCampaignCardClick(e, campaign)}/>
        } else {
          return <CampaignList key={shortid()} index={index} campaign={campaign} reloadCampaigns={(e) => this.fetchData(
            '', '', 0)} onCardClick={(e, campaign) => this.onCampaignCardClick(e, campaign)}/>
        }
      }
    });

    return <HorizontalLayout className='CNINFO-CnerOverview py-[8px] justify-center md:justify-start flex-wrap md:flex-nowrap'>
      <CampaignCardNew
        statusFilterDefaultValue={this.state.activeStatusFilter} onResetFilters={(e) => this.onResetFilters(e)}
        reloadCampaigns={(e) => this.fetchData('', '', 0)}
        onStatusFilterChange={(e, newFilter) => this.setOnStatusFilterChange(e, newFilter)}
        onFilterInputChange={(e, id, value) => this.onFilterInputChange(e, id, value)}
        searchInputDefaultValue={this.state.filterText}/>
      <VerticalLayout className='md:ml-[320px] pl-2'>
        <HorizontalLayout className='flex-wrap justify-start gap-5'>
          <HorizontalLayout className='justify-center'>
            <ToggleButtonGroup value={this.state.layoutType}>
              <ToggleButton
                value={CnerOverview.LAYOUT_GRID}
                onClick={(e) => this.changeLayout(CnerOverview.LAYOUT_GRID)}>
                <ViewModule/>
              </ToggleButton>
              <ToggleButton
                value={CnerOverview.LAYOUT_LIST}
                onClick={(e) => this.changeLayout(CnerOverview.LAYOUT_LIST)}>
                <ViewList/>
              </ToggleButton>
            </ToggleButtonGroup>
          </HorizontalLayout>
          {campaigns}
        </HorizontalLayout>
      </VerticalLayout>
    </HorizontalLayout>;
  }
}

CnerOverview.propTypes = {
  layout: PropTypes.object, parent: PropTypes.object, id: PropTypes.number
}
export default CnerOverview;
